export const REMEMBER_ME_WARNING = 'rememberMeWarning';
export const DBET_USER_DATA = 'dbetUserData';
export const GENERATED_IMAGE_SIZE = 50;
